import { s as styleInject } from './style-inject.es-1f59c1d0.js';

var css_248z = ".spring-backdrop{height:100vh;left:0;position:fixed;top:0;width:100%}.spring-backdrop:not(.bg-transparent){--tw-bg-opacity:1;--tw-bg-opacity:0.7;--tw-backdrop-blur:blur(10px);-webkit-backdrop-filter:var(--tw-backdrop-filter);backdrop-filter:var(--tw-backdrop-filter);background-color:rgba(36,38,33,var(--tw-bg-opacity))}";
styleInject(css_248z);

var SpringBackdrop = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "spring-backdrop",
      class: [{
        'bg-transparent': _vm.transparent
      }, _vm.zIndexStyle],
      on: {
        "click": function ($event) {
          return _vm.$emit('click');
        }
      }
    }, [_vm._t("default")], 2);
  },
  staticRenderFns: [],
  // Name
  name: 'SpringBackdrop',
  // Props
  props: {
    transparent: {
      type: Boolean
    },
    zIndex: {
      type: String,
      default: 'z-20'
    }
  },
  computed: {
    zIndexStyle() {
      return this.zIndex;
    }
  }
};

export { SpringBackdrop as S };
